
import { useState } from "react";
import { toast } from "@/components/ui/use-toast";

export function useVideoHandler(onVideoEnd: () => Promise<any>) {
  const [videoLoaded, setVideoLoaded] = useState(false);
  const [videoError, setVideoError] = useState(false);

  const handleVideoLoad = () => {
    console.log("Video loaded successfully");
    setVideoLoaded(true);
    setVideoError(false);
  };

  const handleVideoError = () => {
    console.error("Video failed to load");
    setVideoError(true);
    setVideoLoaded(false);
    toast({
      title: "Video Loading Error",
      description: "We couldn't load the video. Please try again later.",
      variant: "destructive"
    });
  };
  
  const handleVideoEndEvent = async () => {
    console.log("Video ended");
    await onVideoEnd();
  };

  return {
    videoLoaded,
    videoError,
    handleVideoLoad,
    handleVideoError,
    handleVideoEndEvent
  };
}
